import axios from "axios";
import { apiURL } from "utils/config";
import { getAuthorizationHeaders } from "./auth";
import store from "../store";

export const getContracts = () => {
  const schoolId = store.getState().user.selectedSchool?.id;
  if (!schoolId) return Promise.resolve({ data: null });
  return axios({
    url: `${apiURL}/school/${schoolId}/contract`,
    method: "GET",
    headers: getAuthorizationHeaders(),
  });
};

export const getKkContractsGroups = () => {
  const schoolId = store.getState().user.selectedSchool?.id;
  if (!schoolId) return Promise.resolve({ data: null });
  return axios({
    url: `${apiURL}/school/${schoolId}/dashboard/klingklong`,
    method: "GET",
    headers: getAuthorizationHeaders(),
  });
};

export const getKkBirthdaysStudent = () => {
  const schoolId = store.getState().user.selectedSchool?.id;
  if (!schoolId) return Promise.resolve({ data: null });
  return axios({
    url: `${apiURL}/school/${schoolId}/dashboard/klingklong-birthdays-student`,
    method: "GET",
    headers: getAuthorizationHeaders(),
  });
};

export const getKkBirthdaysParent = () => {
  const schoolId = store.getState().user.selectedSchool?.id;
  if (!schoolId) return Promise.resolve({ data: null });
  return axios({
    url: `${apiURL}/school/${schoolId}/dashboard/klingklong-birthdays-parent`,
    method: "GET",
    headers: getAuthorizationHeaders(),
  });
};

export const getContractsWithFilter = (query) => {
  const schoolId = store.getState().user.selectedSchool?.id;
  if (!schoolId) return Promise.resolve({ data: null });
  if (query === "active") {
    return axios({
      url: `${apiURL}/school/${schoolId}/contract?status=${query}&dashboard=true`,
      method: "GET",
      headers: getAuthorizationHeaders(),
    });
  } else {
    return axios({
      url: `${apiURL}/school/${schoolId}/contract?status=${query}`,
      method: "GET",
      headers: getAuthorizationHeaders(),
    });
  }
};

export const getExpiredProfiles = () => {
  const schoolId = store.getState().user.selectedSchool?.id;
  if (!schoolId) return Promise.resolve({ data: null });
  return axios({
    url: `${apiURL}/school/${schoolId}/expiredProfiles`,
    method: "GET",
    headers: getAuthorizationHeaders(),
  });
};

export const removeContractAlert = (data) => {
  return axios({
    url: `${apiURL}/readNotification`,
    method: "POST",
    headers: getAuthorizationHeaders(),
    data: data,
  });
};
